
export default {
  name: 'FilterRating',
  props: {
    dataFilter: {
      type: Object,
      default: () => ({})
    },
    buttonLoadMore: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 5
    },
    textValue: {
      type: String,
      default: 'id'
    },
    textName: {
      type: String,
      default: 'value'
    },
    keyFilter: {
      type: String,
      default: ''
    },
    updateState: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      listData: [],
      listValue: [],
      showListFilter: true,
      loadMore: false,
      itemValue: 'id',
      itemName: 'value'
    }
  },
  watch: {
    'listValue'() {
      this.changeListValue()
    },
    'updateState.status'() {
      const data = []
      this.dataFilter.list.forEach(filter => {
        if (this.updateState.list.includes(String(filter)) || this.updateState.list.includes(filter)) {
          data.push(filter)
        }
      })
      this.listValue = data
    }
  },
  created() {
    if (this.textValue) {
      this.itemValue = this.textValue
    }
    if (this.textName) {
      this.itemName = this.textName
    }
  },
  methods: {
    resetValidate(ref) {
      this.$refs.accountForm.fields.find((f) => f.prop === ref).clearValidate()
      this.accountForm.errors[ref] = ''
    },
    checkShow(index) {
      if (this.buttonLoadMore !== true) return true
      if ((this.loadMore === false) && (index >= this.limit)) return false
      return true
    },
    changeListValue() {
      const list = []
      const listValue = []
      this.dataFilter.list.forEach(data => {
        if (this.listValue.includes(data)) {
          list.push(this.$t('filter.rate_show', { star: data }))
          listValue.push(data)
        }
      })
      this.$emit('change', {
        type: this.keyFilter,
        value: list,
        list: listValue,
        title: this.$t('filter.rating')
      })
    }
  }
}
